<template>
  <div>
    <h2>异常预警中心</h2>

    <el-row :gutter="16" style="margin-bottom:20px;">
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card" style="border-left:4px solid #F56C6C;">
          <div class="stat-value" style="color:#F56C6C;">{{ summary.highRiskCount }}</div>
          <div class="stat-label">高风险</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card" style="border-left:4px solid #E6A23C;">
          <div class="stat-value" style="color:#E6A23C;">{{ summary.mediumRiskCount }}</div>
          <div class="stat-label">中风险</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card" style="border-left:4px solid #67C23A;">
          <div class="stat-value" style="color:#67C23A;">{{ summary.handledCount }}</div>
          <div class="stat-label">已处理</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card" style="border-left:4px solid #409EFF;">
          <div class="stat-value" style="color:#409EFF;">{{ summary.totalCount }}</div>
          <div class="stat-label">全部</div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="search-bar">
      <el-col :span="4">
        <el-select v-model="search.warningType" placeholder="预警类型" clearable style="width:100%;">
          <el-option label="采购为0但存在检测" value="PURCHASE_ZERO_DETECT_EXIST" />
          <el-option label="检测量超出采购能力" value="USAGE_RATE_OVER_100" />
          <el-option label="检测量接近采购上限" value="USAGE_RATE_OVER_50" />
          <el-option label="长期未采购但持续检测" value="LONG_TIME_NO_PURCHASE" />
          <el-option label="共享设备检测异常偏高" value="SHARED_DEVICE_ABNORMAL" />
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.riskLevel" placeholder="风险等级" clearable style="width:100%;">
          <el-option label="高风险" value="HIGH" />
          <el-option label="中风险" value="MEDIUM" />
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.handleStatus" placeholder="处理状态" clearable style="width:100%;">
          <el-option label="未处理" value="UNHANDLED" />
          <el-option label="已处理" value="HANDLED" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-date-picker v-model="search.startDate" type="date" placeholder="开始日期"
          value-format="YYYY-MM-DD" style="width:100%;" clearable />
      </el-col>
      <el-col :span="4">
        <el-date-picker v-model="search.endDate" type="date" placeholder="结束日期"
          value-format="YYYY-MM-DD" style="width:100%;" clearable />
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="doSearch">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width:100%;" v-loading="loading">
      <el-table-column label="预警等级" width="90" align="center">
        <template v-slot="scope">
          <el-tag :type="scope.row.riskLevel === 'HIGH' ? 'danger' : 'warning'" size="small">
            {{ scope.row.riskLevelText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="warningTypeText" label="预警类型" min-width="150" />
      <el-table-column label="账户/设备" min-width="120">
        <template v-slot="scope">
          {{ scope.row.accountName || '-' }} / {{ scope.row.deviceNo || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="warningContent" label="预警内容" min-width="180" show-overflow-tooltip />
      <el-table-column prop="createTime" label="触发时间" width="170" />
      <el-table-column label="状态" width="90" align="center">
        <template v-slot="scope">
          <el-tag :type="scope.row.handleStatus === 'HANDLED' ? 'success' : 'info'" size="small">
            {{ scope.row.handleStatus === 'HANDLED' ? '已处理' : '未处理' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" align="center">
        <template v-slot="scope">
          <el-button type="text" size="small" @click="viewDetail(scope.row)">查看详情</el-button>
          <el-button v-if="scope.row.handleStatus !== 'HANDLED'" type="text" size="small"
            style="color:#E6A23C;" @click="handleWarning(scope.row)">标记处理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page.current" :page-size="page.pageSize" :total="page.total"
        layout="total, sizes, prev, pager, next, jumper" />
    </div>

    <el-dialog title="处理预警" v-model="handleDialogVisible" width="500px">
      <el-form label-width="80px">
        <el-form-item label="处理备注">
          <el-input v-model="handleRemark" type="textarea" :rows="3" placeholder="请输入处理备注" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="handleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitHandle">确认处理</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getWarningSummary, fetchWarningPage, handleWarning as handleWarningApi } from "@/api/reagentMonitor";

export default {
  data() {
    return {
      search: { warningType: "", riskLevel: "", handleStatus: "", startDate: "", endDate: "" },
      tableData: [],
      page: { current: 1, pageSize: 10, total: 0 },
      loading: false,
      summary: { highRiskCount: 0, mediumRiskCount: 0, handledCount: 0, totalCount: 0 },
      handleDialogVisible: false,
      currentWarning: null,
      handleRemark: "",
    };
  },
  created() {
    this.loadSummary();
    this.doSearch();
  },
  methods: {
    async loadSummary() {
      try {
        const res = await getWarningSummary();
        if (res.code === 200) {
          this.summary = res.data || this.summary;
        }
      } catch (e) { console.error(e); }
    },
    async doSearch() {
      this.loading = true;
      try {
        const res = await fetchWarningPage({
          warningType: this.search.warningType || undefined,
          riskLevel: this.search.riskLevel || undefined,
          handleStatus: this.search.handleStatus || undefined,
          startDate: this.search.startDate || undefined,
          endDate: this.search.endDate || undefined,
          current: this.page.current,
          pageSize: this.page.pageSize,
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.page.total = res.data.total || 0;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    resetSearch() {
      this.search = { warningType: "", riskLevel: "", handleStatus: "", startDate: "", endDate: "" };
      this.page.current = 1;
      this.doSearch();
    },
    viewDetail(row) {
      this.$router.push({ path: `/reagent-monitor/warning/detail/${row.id}` });
    },
    handleWarning(row) {
      this.currentWarning = row;
      this.handleRemark = "";
      this.handleDialogVisible = true;
    },
    async submitHandle() {
      try {
        const res = await handleWarningApi({
          warningId: this.currentWarning.id,
          handleRemark: this.handleRemark,
        });
        if (res.code === 200) {
          this.$message.success("处理成功");
          this.handleDialogVisible = false;
          this.loadSummary();
          this.doSearch();
        }
      } catch (e) { console.error(e); }
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.current = 1;
      this.doSearch();
    },
    handleCurrentChange(page) {
      this.page.current = page;
      this.doSearch();
    },
  },
};
</script>

<style scoped>
.search-bar { margin-bottom: 16px; }
.pagination { margin-top: 16px; display: flex; justify-content: flex-end; }
.stat-card { text-align: center; padding: 10px 0; }
.stat-value { font-size: 28px; font-weight: bold; }
.stat-label { font-size: 14px; color: #909399; margin-top: 4px; }
</style>
